"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global window */
var queuedUpdate = false;
var pendingState = void 0;

var updatePageOptions = function updatePageOptions() {
    queuedUpdate = false;
    if (!window.adRenderer) {
        return;
    }
    window.adRenderer.setPageOptions(pendingState);
};

var handleStateChangeOnClient = function handleStateChangeOnClient(state) {
    pendingState = state;
    if (!queuedUpdate) {
        queuedUpdate = window.requestAnimationFrame(updatePageOptions);
    }
};

exports.default = handleStateChangeOnClient;
//# sourceMappingURL=handleStateChangeOnClient.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/PageOptions/handleStateChangeOnClient.js
 ** module id = 462
 ** module chunks = 1
 **/